module.exports = __webpack_public_path__ + "img/sass.1b5bf5cc.png";